(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _stickyHome = __webpack_require__(9);
	
	var _stickyHome2 = _interopRequireDefault(_stickyHome);
	
	var _sectionLoadUtils = __webpack_require__(10);
	
	var _sectionLoadUtils2 = _interopRequireDefault(_sectionLoadUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Logger.debug('script home loaded');
	
	/** init **************************************************************************************************************/
	var app = Voonto.getInstance();
	var nibara = window.nibara;
	var feature = nibara.feature;
	
	var libPath = app.lookup('vocento.config.nibara').libPath;
	if (libPath === undefined) {
	  throw 'nibara libPath config is empty';
	}
	
	/** sticky voc home init **********************************************************************************************/
	if (feature.stickyAds && (Voonto.is.desktop() || Voonto.is.tablet())) {
	  Logger.debug("feature stickyAds active");
	  var stickyHome = new _stickyHome2.default();
	  stickyHome.iniciar();
	  Voonto.$('[data-section="main"]').find('[data-sticky-home]').on('vam:slotrendered', function () {
	    Logger.info('stickyHome over elemente id: ' + Voonto.$(this).attr('id'));
	    stickyHome.addElement(this);
	    stickyHome.recalcularTodo();
	  });
	}
	
	// jquery Stick feature
	if (feature.jqStickyAds && (Voonto.is.desktop() || Voonto.is.tablet())) {
	  Logger.debug("feature jqStickyAds active");
	  app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(function () {
	    Voonto.$('[data-section="main"]').find('[data-sticky-home]').on('vam:slotrendered', function () {
	      Logger.info('jqStickyHome over elemente id: ' + Voonto.$(this).attr('id'));
	      Voonto.$(this).stick_in_parent({ offset_top: 45 });
	    });
	  });
	}
	
	// change section in sticky header
	_sectionLoadUtils2.default.onClickMainHome(Voonto.$('span.cabecera-sticky span.contenido-cabecera'));
	_sectionLoadUtils2.default.onClickMainHome(Voonto.$('.cabecera'));
	
	/** default change url */
	_sectionLoadUtils2.default.changeSectionName(Voonto.$('[data-section="main"]'));
	
	// vuelta atras y cambio de url
	if (feature.homeBacktrace) {
	  Logger.debug("feature homeBacktrace active");
	  /** force auto ever */
	  history.scrollRestoration = 'auto';
	
	  /** create history with main if not exist */
	  if (history.state === null) {
	    history.replaceState({ section: 'main' }, 'main', '/' + window.location.search + window.location.hash);
	  }
	
	  nibara.isBack = _sectionLoadUtils2.default.isBackView() === true;
	
	  /** search link event to find section owner and change lastview in session  *******/
	  //sectionEventUtils.onClickSetHistoryHome(Voonto.$('main'));
	  var $mainChildren = Voonto.$('main').children();
	  _sectionLoadUtils2.default.onClickTerrazaHome($mainChildren.not('[data-section]'));
	  _sectionLoadUtils2.default.onClickSetHistoryHome($mainChildren.filter('main[data-section]'));
	  _sectionLoadUtils2.default.onClickSetHistoryHome(Voonto.$('nav.navegacion'));
	  _sectionLoadUtils2.default.onClickSetHistoryHome(Voonto.$('span.cabecera-sticky.visible span.contenido-cabecera span.titulo-seccion'));
	  _sectionLoadUtils2.default.onClickSetHistoryHome(Voonto.$('span.nombre-seccion'));
	
	  /** go to section view */
	  if (_sectionLoadUtils2.default.isBackView() === true && history.state.lastSectionView !== 'main') {
	    nibara.lastSectionView = history.state.lastSectionView;
	    var $lastSectionViewElm = Voonto.$('[data-section=' + nibara.lastSectionView + ']');
	    if ($lastSectionViewElm && _typeof($lastSectionViewElm.offset()) === "object") {
	      /** location temporally disabled */
	      history.scrollRestoration = 'manual';
	      Voonto.$('.oreja').removeClass('fija');
	      nibara.sectionLocationWatch = setInterval(function () {
	        window.scrollTo(0, $lastSectionViewElm.offset().top + 5);
	      }, 10);
	    }
	  }
	}
	
	/** scroll  event
	 * sticky skies
	 * cmv_wallpaper
	 * @type {boolean}
	 */
	if (Voonto.is.desktop()) {
	  var stickySkyLocked = false;
	  var $window = Voonto.$(window);
	  var $mainSection = Voonto.$('[data-section="main"]');
	  Voonto.$(window).on("scroll", nibara.nTools.throttle(50, function () {
	    var top = $window.scrollTop();
	    var mainHeigh = $mainSection.height() + $mainSection.offset().top - $window.height() + 100;
	    if (top > mainHeigh && stickySkyLocked === false) {
	      stickySkyLocked = true;
	      Voonto.$('.oreja').removeClass('fija').css('position', 'absolute').css('top', mainHeigh);
	      Voonto.$('.cmv_wallpaper').hide();
	    }
	    if (top < mainHeigh && stickySkyLocked === true) {
	      stickySkyLocked = false;
	      Voonto.$('.oreja').addClass('fija').removeAttr('style');
	      Voonto.$('.cmv_wallpaper').show();
	    }
	  }));
	}
	
	/**
	 * Scroll direction
	 * Set tracking var scroll direction
	 * @type {boolean}
	 */
	var lastScrollPosition = 0;
	window.vocento.tracking.comscore.scrollDireccion = '';
	Voonto.$(window).on("scroll", function () {
	  var newScrollPosition = window.scrollY;
	  if (newScrollPosition < lastScrollPosition) {
	    window.vocento.tracking.comscore.scrollDireccion = 'up';
	  } else {
	    window.vocento.tracking.comscore.scrollDireccion = 'down';
	  }
	  lastScrollPosition = newScrollPosition;
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CLASS_TOP = "top";
	var CLASS_FIXED = "fijo";
	var CLASS_BOTTOM = "bottom";
	var MINIMUM_HEIGHT = 150;
	
	/**
	 * @author David Díaz <ddsanantonio@abc.es>
	 * @author Felipe Galindo <fgalindo@vocento.com>
	 */
	function StickyHome() {
	
	    //    if (StickyHome.prototype._singletonInstance) {
	    //      return StickyHome.prototype._singletonInstance;
	    //    }
	    //    StickyHome.prototype._singletonInstance = this;
	    if (window.stickyHome) {
	        return window.stickyHome;
	    }
	
	    /**
	     * Datos del Elemento al que hacer sticky
	     * @typedef {Object} StickyItem
	     * @property {HTMLElement} ele - Elemento sticky
	     * @property {int} alto - Alto del elemento en pixels
	     * @property {HTMLElement} padre - Contenedor del sticky
	     * @property {int} altoPadre - Alto del contenedor
	     * @property {int} recorrido - Espacio disponible para mover el sticky
	     * @property {string} clase - Estilos asignado al elemento (top|fixed|bottom)
	     * @property {boolen} activo - Indica si realizar sticky al elemento
	     */
	
	    /** @var {StickyItem[]}  */
	    var robapaginas = [];
	    var initialized = false;
	    var paddingTop = 64;
	    var paddingBottom = 23;
	
	    function getRobas() {
	        return robapaginas;
	    }
	
	    /**
	     * @param {HTMLElement} ele 
	     */
	    function addElement(ele) {
	        // Si ya está insertado no hacer nada
	        for (var i = 0, n = robapaginas.length; i < n; i++) {
	            if (ele === robapaginas[i].ele) {
	                return;
	            }
	        }
	
	        ele.classList.add(CLASS_TOP);
	        var roba = {
	            'ele': ele,
	            'alto': ele.offsetHeight,
	            'padre': ele.parentElement,
	            'altoPadre': ele.parentElement.offsetHeight,
	            'recorrido': ele.parentElement.offsetHeight - ele.offsetHeight - paddingBottom,
	            'activo': false,
	            'clase': CLASS_TOP
	        };
	        robapaginas.push(roba);
	        //Logger.info('sticky addElement', roba);
	    }
	
	    /**
	     * @param {StickyItem} roba
	     */
	    function robaAltoAddClass(roba) {
	        if (roba.alto > 250 && roba.altoPadre < 623) {
	            roba.padre.classList.add('alto');
	        }
	    }
	
	    function iniciar(top, bottom) {
	        if (initialized) return;
	        if (top) {
	            paddingTop = top;
	        }
	        if (bottom) {
	            paddingBottom = bottom;
	        }
	        document.addEventListener('scroll', function () {
	            var roba = void 0;
	            for (var i = 0, n = robapaginas.length; i < n; i++) {
	                roba = robapaginas[i];
	                recalcular(roba);
	                sticky(roba);
	            }
	        });
	        initialized = true;
	    }
	
	    /**
	     * @param {StickyItem} roba
	     */
	    function sticky(roba) {
	        if (roba.activo) {
	            var top = paddingTop - roba.padre.getBoundingClientRect().top;
	            if (top >= 0 && top <= roba.recorrido) {
	                if (roba.clase === CLASS_FIXED) return;
	                roba.ele.classList.remove(roba.clase);
	                roba.ele.classList.add(CLASS_FIXED);
	                roba.clase = CLASS_FIXED;
	            } else if (top < 0) {
	                if (roba.clase === CLASS_TOP) return;
	                roba.ele.classList.remove(roba.clase);
	                roba.ele.classList.add(CLASS_TOP);
	                roba.clase = CLASS_TOP;
	            } else {
	                if (roba.clase === CLASS_BOTTOM) return;
	                roba.ele.classList.remove(roba.clase);
	                roba.ele.classList.add(CLASS_BOTTOM);
	                roba.clase = CLASS_BOTTOM;
	            }
	        } else if (roba.clase !== CLASS_TOP) {
	            roba.ele.classList.remove(roba.clase);
	            roba.ele.classList.add(CLASS_TOP);
	            roba.clase = CLASS_TOP;
	        }
	    }
	
	    function recalcularTodo() {
	        var roba = void 0;
	        for (var i = 0, n = robapaginas.length; i < n; i++) {
	            roba = robapaginas[i];
	            recalcular(roba);
	            robaAltoAddClass(roba);
	            sticky(roba);
	        }
	    }
	
	    /**
	     * @param {StickyItem} roba
	     */
	    function recalcular(roba) {
	        roba.altoPadre = roba.padre.offsetHeight;
	        roba.alto = roba.ele.offsetHeight;
	        roba.recorrido = roba.altoPadre - roba.alto - paddingBottom;
	        roba.activo = roba.recorrido > MINIMUM_HEIGHT;
	        //Logger.debug('recalcular', roba);
	    }
	
	    return window.stickyHome = {
	        "addElement": addElement,
	        "iniciar": iniciar,
	        "getRobas": getRobas,
	        "recalcularTodo": recalcularTodo,
	        "setTop": function setTop(val) {
	            paddingTop = val;
	        },
	        "setBottom": function setBottom(val) {
	            paddingBottom = val;
	        }
	    };
	}
	
	exports.default = StickyHome;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var trackUtils = __webpack_require__(11);
	
	var SectionLoadUtils = function () {
	  function SectionLoadUtils() {
	    _classCallCheck(this, SectionLoadUtils);
	  }
	
	  _createClass(SectionLoadUtils, null, [{
	    key: 'changeUrl',
	
	
	    /**
	     * Only modify current url to section
	     * @param $elm
	     */
	    value: function changeUrl($elm) {
	      var section = $elm.data('section');
	      var segment = '';
	      if (section === 'main') {
	        segment = '/';
	      } else {
	        segment = $elm.data('section-url');
	      }
	      segment += window.location.search + window.location.hash;
	
	      history.replaceState({ "section": section }, section, segment);
	    }
	
	    /**
	     * Change section name in header
	     * @param $elm
	     */
	
	  }, {
	    key: 'changeSectionName',
	    value: function changeSectionName($elm) {
	      Logger.info('[Header][Sticky] Change section name');
	      if (Voonto.is.mobile() === true) {
	        var $stickySectionName = Voonto.$('.cabecera-sticky .nombre-seccion>a');
	        var nsChannel = window.vocento.tracking.comscore.voc_site;
	        var nsLinkname = window.vocento.tracking.comscore.voc_se;
	        var trackingMark = '#ns_campaign=logo-seccion&ns_mchannel=' + nsChannel + '&ns_source=portada.portada&ns_linkname=' + nsLinkname + '&ns_fee=0';
	
	        if ($elm.data('section') === 'main') {
	          $stickySectionName.attr("href", '/' + trackingMark);
	          $stickySectionName.text('Portada');
	        } else {
	          $stickySectionName.attr("href", $elm.data('section-url') + trackingMark);
	          $stickySectionName.text($elm.data('section-name'));
	        }
	      } else {
	        var _nsChannel = window.vocento.tracking.comscore.voc_site;
	
	        var _nsLinkname = window.vocento.tracking.comscore.voc_se;
	        if ($elm.data('section') === 'main') {
	          if (window.vocento.tracking.comscore.voc_s1.length > 0) {
	            _nsLinkname = _nsLinkname + '.' + window.vocento.tracking.comscore.voc_s1;
	          }
	        } else {
	          _nsLinkname = $elm.data('tracking').comscore.voc_se;
	          if ($elm.data('tracking').comscore.voc_s1.length > 0) {
	            _nsLinkname = _nsLinkname + '.' + $elm.data('tracking').comscore.voc_s1;
	          }
	        }
	
	        var _trackingMark = '#ns_campaign=logo-seccion&ns_mchannel=' + _nsChannel + '&ns_source=portada.portada&ns_linkname=' + _nsLinkname + '&ns_fee=0';
	
	        var _$stickySectionName = Voonto.$('.cabecera-sticky .titulo-seccion>a');
	        if ($elm.data('section') === 'main') {
	          _$stickySectionName.attr("href", '/' + _trackingMark);
	          _$stickySectionName.text('Portada');
	        } else {
	          _$stickySectionName.attr("href", $elm.data('section-url') + _trackingMark);
	          _$stickySectionName.text($elm.data('section-name'));
	        }
	      }
	    }
	
	    /**
	     * Unbind click on section title an bind on with last section
	     * @param $elm
	     */
	
	  }, {
	    key: 'onClickSectionName',
	    value: function onClickSectionName($elm) {
	      if (Voonto.is.desktop()) {
	        var $sectionName = $('.cabecera-sticky > span > .titulo-seccion');
	        $sectionName.off('click');
	        $sectionName.on('click', function () {
	          history.replaceState({ section: 'main', lastSectionView: $elm.data('section') }, 'main', '/' + window.location.search);
	        });
	      } else if (Voonto.is.mobile()) {
	        var _$sectionName = $('.nombre-seccion');
	        _$sectionName.off('click');
	        _$sectionName.on('click', function () {
	          history.replaceState({ section: 'main', lastSectionView: $elm.data('section') }, 'main', '/' + window.location.search);
	        });
	      }
	    }
	
	    /**
	     * Listen all click events to replace history
	     * @param $elm
	     */
	
	  }, {
	    key: 'onClickSetHistoryHome',
	    value: function onClickSetHistoryHome($elm) {
	      $elm.find('a').on('click', function () {
	        var $link = Voonto.$(this);
	        var target = $link.attr('target');
	        if (target && target !== '_self') {
	          return;
	        }
	
	        var lastSectionView = 'main';
	        var $parent = $link.closest("[data-section]");
	        if ($parent) {
	          lastSectionView = $parent.data('section');
	        }
	        history.replaceState({ section: 'main', lastSectionView: lastSectionView }, 'main', '/' + window.location.search);
	      });
	    }
	  }, {
	    key: 'onClickTerrazaHome',
	    value: function onClickTerrazaHome($elm) {
	      $elm.find('a').on('click', function () {
	        var $link = Voonto.$(this);
	        var target = $link.attr('target');
	        if (target && target !== '_self') {
	          return;
	        }
	
	        var lastSectionView = 'main';
	        var $prev = $link.parentsUntil('main').last().prev("[data-section]");
	        if ($prev) {
	          lastSectionView = $prev.data('section');
	        }
	
	        history.replaceState({ section: 'main', lastSectionView: lastSectionView }, 'main', '/' + window.location.search);
	      });
	    }
	  }, {
	    key: 'onClickSectionMenu',
	    value: function onClickSectionMenu($elm) {
	      $elm.on('click', function () {
	        $elm.next().slideToggle();
	      });
	
	      $elm.on('click', function () {
	        var tipoAnimacion = $elm.data('boton-animado');
	        Logger.info('tipoAnimacion ' + tipoAnimacion);
	        switch (tipoAnimacion) {
	          case 'menu':
	            $elm.toggleClass('abierto');
	        }
	      });
	    }
	  }, {
	    key: 'onClickMainHome',
	    value: function onClickMainHome($elm) {
	      $elm.find('a').on('click', function () {
	        window.scrollTo(0, 0);
	        location.reload();
	      });
	    }
	
	    /** populate vars into global scope and track with vtm */
	
	  }, {
	    key: 'tracking',
	    value: function tracking($elm) {
	      try {
	        var tracking = null;
	
	        /** if is section, get tracking from data */
	        if ($elm.data('section') !== 'main' && typeof $elm.data('tracking') !== 'undefined') {
	          tracking = $elm.data('tracking');
	        }
	
	        /** if is main section, get data from main object */
	        if ($elm.data('section') === 'main') {
	          tracking = window.vocento.tracking;
	        }
	
	        Logger.info('Tracking section: ' + $elm.data('section'));
	
	        Voonto.getInstance().when('vtm:ready').then(function () {
	          TagManager.set({
	            seccion: tracking.comscore.voc_se,
	            subseccion1: tracking.comscore.voc_s1,
	            subseccion2: tracking.comscore.voc_s2,
	            subseccion3: tracking.comscore.voc_s3,
	            subseccion4: tracking.comscore.voc_s4,
	            titular: tracking.comscore.voc_tn,
	            tipoDominio: tracking.comscore.voc_pr,
	            edicion: tracking.comscore.voc_ed,
	            tipoContenido: tracking.comscore.voc_tc,
	            tipoContenidoA: tracking.comscore.voc_tcnew,
	            plataformaContenido: tracking.comscore.voc_pl,
	            sistemaPublicacion: tracking.comscore.voc_pu,
	            fechaPrimeraPublicacion: tracking.comscore.voc_fep,
	            fechaModificacion: tracking.comscore.voc_fem,
	            idioma: tracking.comscore.voc_idi,
	            IDEvolok: tracking.comscore.voc_pw_pid,
	            firmaAutor: tracking.comscore.voc_au,
	            origenContenido: tracking.comscore.voc_or,
	            topics: tracking.comscore.voc_top,
	            scrollInfinito: true,
	            scrollInfinitoHome: $elm.data('section-seq'),
	            scrollDireccion: window.vocento.tracking.comscore.scrollDireccion
	
	          }).track();
	
	          Logger.info('VTM dataLayer');
	          Logger.info(TagManager.get());
	
	          /** GTM datalayer scroll push event */
	          window.dataLayer.push({ 'event': 'scrollview' });
	        }, function (reason) {
	          trackUtils.imgTrack('vtm-ready-error-section', reason);
	          Logger.error('Error while vtm:ready promise: ', reason);
	        });
	      } catch (ex) {
	        trackUtils.imgTrack('vtm-error-exception-section', ex);
	        Logger.error('Exception while tracking section: ', ex);
	      }
	    }
	
	    /**
	     * return true if is back view
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'isBackView',
	    value: function isBackView() {
	      return typeof history.state !== 'undefined' && history.state !== null && typeof history.state.lastSectionView !== 'undefined';
	    }
	  }, {
	    key: 'disableHomeTopAds',
	    value: function disableHomeTopAds() {
	      Voonto.$('[data-voc-vam-position]').each(function (k, v) {
	        var $v = Voonto.$(v);
	        $v.attr('data-voc-vam-position-back', $v.attr('data-voc-vam-position'));
	        $v.removeAttr('data-voc-vam').removeAttr('data-voc-vam-position');
	      });
	    }
	  }, {
	    key: 'enableHomeTopAds',
	    value: function enableHomeTopAds() {
	      Voonto.$('[data-voc-vam-position-back]').each(function (k, v) {
	        var $v = Voonto.$(v);
	        $v.attr('data-voc-vam-position', $v.attr('data-voc-vam-position-back'));
	        $v.attr('data-voc-vam', '');
	      });
	    }
	  }]);
	
	  return SectionLoadUtils;
	}();
	
	;
	
	exports.default = SectionLoadUtils;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	
	  /**
	   * write img element with error to track exceptions in kibana
	   * @param key
	   * @param message
	   * @return {HTMLImageElement}
	   */
	  imgTrack: function imgTrack(key, message) {
	    var today = new Date(),
	        date = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate(),
	        time = today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds(),
	        dateTime = date + '-' + time,
	        src = '/comun/img/dtm-track.jpg',
	        querystring = encodeURI('key=' + key + '&datetime=' + dateTime + '&message=' + message),
	        img = document.createElement('img');
	    img.src = src + '?' + querystring;
	    return img;
	  },
	  exportRootVars: function exportRootVars() {
	    for (var key in window.vocento.tracking.root) {
	      if (vocento.tracking.root.hasOwnProperty(key)) {
	        window[key] = vocento.tracking.root[key];
	      }
	    }
	  },
	  exportComscoreVars: function exportComscoreVars() {
	    /** solo exportamos algunas variables, ya que VTM tiene prioridad sobre las vocvars y pisariamos sus valores */
	    window.voc_ate = window.vocento.tracking.comscore.voc_ate;
	    window.voc_top = window.vocento.tracking.comscore.voc_top;
	    window.voc_site = window.vocento.tracking.comscore.voc_site;
	    window.voc_tcnew = window.vocento.tracking.comscore.voc_tcnew;
	    window.voc_tc = window.vocento.tracking.comscore.voc_tc;
	    window.voc_se = window.vocento.tracking.comscore.voc_se;
	    window.voc_au = window.vocento.tracking.comscore.voc_au;
	    window.voc_s1 = window.vocento.tracking.comscore.voc_s1;
	    window.voc_s2 = window.vocento.tracking.comscore.voc_s2;
	    window.voc_s3 = window.vocento.tracking.comscore.voc_s3;
	    window.voc_s4 = window.vocento.tracking.comscore.voc_s4;
	    window.voc_npc = window.vocento.tracking.comscore.voc_npc;
	  },
	  setTrackBuscadorPlaySummum: function setTrackBuscadorPlaySummum(TagManager) {
	    var main = window.document.getElementsByTagName('main');
	    if (main.length > 0) {
	      var keywords = main[0].getAttribute('data-keywords');
	      var num_entries = main[0].getAttribute('data-num-entries');
	      var buscador = main[0].getAttribute('data-buscador');
	      if (keywords !== null && keywords !== '') {
	        TagManager.set({
	          keyword: this.kebabCase(keywords),
	          tipoBuscador: 'buscador-' + buscador,
	          errorBusqueda: num_entries == 0 ? 'la-busqueda-no-obtuvo-ningun-resultado' : '',
	          nResultados: num_entries
	        });
	      }
	    }
	  },
	  kebabCase: function kebabCase(string) {
	    var result = string;
	    // Convert camelCase capitals to kebab-case.
	    result = result.replace(/([a-z][A-Z])/g, function (match) {
	      return match.substr(0, 1) + '-' + match.substr(1, 1).toLowerCase();
	    });
	    // Convert non-camelCase capitals to lowercase.
	    result = result.toLowerCase();
	    // Convert non-alphanumeric characters to hyphens
	    result = result.replace(/[^-a-z0-9]+/g, '-');
	    // Remove hyphens from both ends
	    result = result.replace(/^-+/, '').replace(/-$/, '');
	    return result;
	  }
	};

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// home-script.js